

class CustomSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.oneTime = this.querySelector('[js-one-time-plan]');
    this.subscribe = this.querySelector('[js-subscription-plan]');
    this.select = this.querySelector('[js-subscription-widget-select]');
    this.onSellingPlanSelectChange = false;
  }

  connectedCallback() {
    this?.oneTime?.addEventListener("change", () => this.toggleDetails());
    this?.subscribe?.addEventListener("change", () => this.toggleDetails());
    this?.select?.addEventListener("change", () => this.onlyForSubscription());
    this.setDefaultSubscriptionFromUrl();
  }

  toggleDetails() {
    let url = this.createUrl();
    if (this.subscribe?.checked) {
      this.select?.setAttribute("name", "selling_plan");
      url = `${url}&selling_plan=${this.select?.value}`
    } else {
      this.select?.removeAttribute("name");
    }
    this.renderPrice(url);
  }

  createUrl() {
    const sectionId = this.closest('[js-main-product-section]')?.getAttribute('data-section-id');
    let url = location.href;
    if(url.includes('?')) {
      url = `${location.href}&section_id=${sectionId}`;
    } else {
      url = `${location.href}?section_id=${sectionId}`;
    }
    return url;
  }

  onlyForSubscription() { 
    let url = this.createUrl();
    url = `${url}&selling_plan=${this.select?.value}`;
     if (this.subscribe?.checked) {
       this.onSellingPlanSelectChange = false;
     } else {
       this.onSellingPlanSelectChange = true;
     }
    this.renderPrice(url);
  } 

  renderPrice(requestUrl) {
    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        html.querySelector('overflow-list[defer]')?.removeAttribute('defer');

        if (this.onSellingPlanSelectChange) {
          const currentPdpMainSectionPrices = this.querySelectorAll('[js-pdp-section-price]');
          const ajaxPdpMainSectionPrices = html?.querySelector('custom-subscription-widget')?.querySelectorAll('[js-pdp-section-price]');
          if(ajaxPdpMainSectionPrices?.length) {
            currentPdpMainSectionPrices.forEach((currentPdpMainSectionPrice, index) => {
              currentPdpMainSectionPrice.replaceWith(ajaxPdpMainSectionPrices[index]);
            })
          }
        } else {
          const currentAtcBtn = document.querySelector('.product-information .Product_information_rightside_new add-to-cart-component .add-to-cart-button [ref="priceContainer"]');
          const ajaxAtcBtn = html.querySelector('.product-information .Product_information_rightside_new add-to-cart-component .add-to-cart-button [ref="priceContainer"]');
          if(currentAtcBtn && ajaxAtcBtn) {
            currentAtcBtn.replaceWith(ajaxAtcBtn);
          } 

          const currentPdpMainSectionPrices = document.querySelectorAll('.product-information [js-pdp-section-price]');
          const ajaxPdpMainSectionPrices = html.querySelectorAll('.product-information [js-pdp-section-price]');
          if(ajaxPdpMainSectionPrices?.length) {
            currentPdpMainSectionPrices.forEach((currentPdpMainSectionPrice, index) => {
              currentPdpMainSectionPrice.replaceWith(ajaxPdpMainSectionPrices[index]);
            })
          }
        }

        this.onSellingPlanSelectChange = false;

      })
  }

  setDefaultSubscriptionFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const shouldDefaultToSubscription = ['subscription', 'subscribe'].some((param) => {
      const value = urlParams.get(param);
      return value === '1' || value === 'true';
    });

    if (!shouldDefaultToSubscription || !this.subscribe || !this.oneTime) return;

    this.subscribe.checked = true;
    this.oneTime.checked = false;

    if (this.select && this.select.options.length) {
      this.select.value = this.select.options[0].value;
      this.select.setAttribute("name", "selling_plan");
    }

    this.toggleDetails();
  }

}

customElements.define('custom-subscription-widget', CustomSubscriptionWidget);
